import { Tab, TabList, TabPanels, Tabs, Flex } from '@chakra-ui/react';
import { PageContent } from 'src/components/PageContent';
import { profilePageBreadcrumb } from './breadcrumb';
import { ProfileRegistrationDataTabContent } from './components/ProfileRegistrationDataTabContent';
import { SecurityTabContent } from './components/SecurityTabContent/SecurityTabContent';
import { useTranslation } from 'react-i18next';

export const Profile = () => {
  const { t } = useTranslation();

  return (
    <PageContent title={t('pages.profile.profile_page_title')} breadcrumbItems={profilePageBreadcrumb}>
      <Tabs borderRadius='card' shadow='md'>
        <Flex overflowX='auto' overflowY='hidden'>
          <TabList
            whiteSpace='nowrap'
            flex={1}
            borderBottomWidth={0}
            borderTopWidth='8px'
            borderTopRadius='8px'
            borderTopColor='gray.200'
          >
            <Tab
              color='text.main'
              _selected={{
                position: 'relative',
                '::before': {
                  content: '""',
                  display: 'block',
                  width: '100%',
                  height: '8px',
                  borderTopLeftRadius: 8,
                  backgroundColor: 'brand.500',
                  position: 'absolute',
                  top: '-8px',
                  zIndex: 99,
                },
              }}
            >
              {t('pages.profile.profile_registration_data_tab')}
            </Tab>
            <Tab
              _selected={{
                position: 'relative',
                '::before': {
                  content: '""',
                  display: 'block',
                  width: '100%',
                  height: '8px',
                  backgroundColor: 'brand.500',
                  position: 'absolute',
                  top: '-8px',
                  zIndex: 99,
                },
              }}
            >
              {t('pages.profile.profile_security_tab')}
            </Tab>
          </TabList>
        </Flex>

        <TabPanels px={4}>
          <ProfileRegistrationDataTabContent />
          <SecurityTabContent />
        </TabPanels>
      </Tabs>
    </PageContent>
  );
};
